let _ = require('lodash');
export const DEFAULT_SERVING_DESC = "1 serving";
export const DEFAULT_SERVING_NUMBER = 1;
export const HIT_TYPE = {
  // This is the text that shows up in the dropdown
  UserHistory: `This User's History`,
  AllNoTags: `All Users' Histories that are missing tags` // Used by datatool only
};

export const SOURCE_NAME = {
  AllRecipes: 'AllRecipes',
  FS_Food: 'FS_Food',
  FS_Recipe: 'FS_Recipe'
}

export function indexIsValid(index) {
  return index >= 0;
}

export function isValidServingNumber(number) {
  return number && number > 0;
}

export function splitByCommonSeparators(text) {
  if (text === '') {
    text = _.trim(text, ' ()[]{},;!:');
    return _.trimEnd(text, '.'); // Only trim periods from the end since they can be decimals
  } else if (!text) {
    return text;
  }

  text = _.trim(text, ' ()[]{},;!:');
  text = _.trimEnd(text, '.'); // Only trim periods from the end since they can be decimals
  return text.split(/[\s,;():]+/); // Skip periods since they can be decimals
}

export function parseServingDescription(servingDescription) {
  let servingDescSplit = splitByCommonSeparators(servingDescription);
  if (servingDescSplit && servingDescSplit.length) {
    let unitNumber = convertTextToNumber(servingDescSplit[0]);
    if (unitNumber) { // This does filter out 0, but it isn't a valid serving size anyway.
      servingDescSplit.shift(); // Remove the unit number if it exists. We'll be joining this back together for the serving unit name.
    } else { // could be in the form of #serving without a space (like '58g')
      let matched = servingDescSplit[0].match(/^[0-9]+/);
      if (matched) {
        unitNumber = matched[0];
        servingDescSplit[0] = servingDescSplit[0].substring(matched[0].length);
      }
    }

    let servingUnit = servingDescSplit.join(' ');
    if (!unitNumber) {
      unitNumber = 1;
    }
    return { servingUnit: servingUnit, servingUnitNumber: unitNumber };
  } else {
    return { servingUnit: servingDescription, servingUnitNumber: 1 };
  }
}

export function createNutritionDataObject(calories, carbs, fat, protein, fiber, sugar) {
  let nutritionData = {};
  if (calories != undefined) {
    nutritionData.calories = calories;
  }

  if (carbs != undefined) {
    nutritionData.carbs = carbs;
  }

  if (fat != undefined) {
    nutritionData.fat = fat;
  }

  if (protein != undefined) {
    nutritionData.protein = protein;
  }

  if (fiber != undefined) {
    nutritionData.fiber = fiber;
    if (carbs != undefined) {
      nutritionData.netCarbs = carbs - fiber;
    }
  }

  if (sugar != undefined) {
    nutritionData.sugar = sugar;
  }

  return nutritionData;
}

export function convertTextToNumber(text) { // '5', '.5', '1/5', and some words like 'one' and 'half' all count
  if (text === undefined) {
    return null;
  }

  let number = _.toNumber(text);
  if (number != null && number != undefined && !_.isNaN(number)) {
    return number;
  }

  number = getFractionAsDecimal(text); // It could be a fraction like '1/2'
  if (number != null && number != undefined && !_.isNaN(number)) {
    return number;
  }

  let textPruned = text.toLowerCase();
  if (textPruned === 'one') {
    return 1;
  } else if (textPruned === 'two') {
    return 2;
  } else if (textPruned === 'three') {
    return 3;
  } else if (textPruned === 'four') {
    return 4;
  } else if (textPruned === 'five') {
    return 5;
  } else if (textPruned === 'six') {
    return 6;
  } else if (textPruned === 'seven') {
    return 7;
  } else if (textPruned === 'eight') {
    return 8;
  } else if (textPruned === 'nine') {
    return 9;
  } else if (textPruned === 'ten') {
    return 10;
  } // Just go up to 10 for now
  else if (textPruned === 'half') { // This function only handles single words. FUTURE: How to handle 'one half' or '1 half'?
    return .5;
  } else if (textPruned === 'quarter') {
    return .25;
  }

  return null;
}

function getFractionAsDecimal(text) {
  let textSplit = text.split('/');
  if (textSplit.length != 2) {
    return null;
  }

  let num = _.toNumber(textSplit[0]);
  if (_.isNaN(num)) {
    return null;
  }

  let den = _.toNumber(textSplit[1]);
  if (_.isNaN(den) || den === 0) {
    return null;
  }

  return num / den;
}


// WEBPACK FOOTER //
// ./src/helpers/esFoodParser.js